import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermission, appName } = params;

	return {
		bulkActions: [],
		addAction: {
			name: 'Add',
			id: 'add',
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.userSegment,
					action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].assignBulkSegments,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		}
	};
};
